import React, { useRef, useState, useEffect, useCallback } from 'react'

export const useHover = () => {
  const [isHovered, setHovered] = useState(false)

  const ref = useRef(null)

  const onMouseOver = useCallback(() => setHovered(true), [setHovered])

  const onMouseOut = useCallback(() => setHovered(false), [setHovered])

  useEffect(() => {
    const currentRef = ref.current

    if (currentRef) {
      currentRef.addEventListener('mouseover', onMouseOver)
      currentRef.addEventListener('mouseout', onMouseOut)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('mouseover', onMouseOver)
        currentRef.removeEventListener('mouseout', onMouseOut)
      }
    }
  })

  return [ref, isHovered]
}
